import tw from 'tailwind-styled-components'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { useTranslation } from 'next-i18next'
import { NavBar, FooterLanding, CountryOffice } from '@foros-fe/core'
import { clientOnlyModule } from '@foros-fe/core/utils'
import { domains } from '@foros-fe/core/config'
import { ContactsDocument, useContactsQuery } from '@foros-fe/graphql'
import { fetchSSRQuery } from '@/utils/apolloClient'

const Map = clientOnlyModule(() => import('@foros-fe/core/components/Maps'))
const Marker = clientOnlyModule(() => import('@foros-fe/core/components/Maps/Marker'))

const Container = tw.div`flex flex-col`
const ContactInfo = tw.p`text-base md:text-lg mb-1 md:mb-2 text-gray-700`

const { phoneNumber, email } = domains.current.contacts
const officeCoordinates = {
  lat: 54.687947,
  lng: 25.264014,
}

export default function Contacts() {
  const { t } = useTranslation('contacts')
  const { data } = useContactsQuery({ fetchPolicy: 'cache-first' })

  return (
    <div>
      <main>
        <NavBar />
        <Container className='container pt-14 pb-0'>
          <p className='text-3xl md:text-5xl font-poppins font-bold mb-6 md:mb-10'>{t('title')}</p>
          <Container className='flex-1 md:flex-row items-center justify-between mb-14'>
            <Container className='max-w-md mr-0 md:mr-36 mb-8 md:mb-0'>
              <ContactInfo>{t('companyName')}</ContactInfo>
              <ContactInfo>{phoneNumber}</ContactInfo>
              <ContactInfo>{email}</ContactInfo>
              <ContactInfo>{t('companyCode')}: 303076369</ContactInfo>
              <ContactInfo>{t('vatPayerCode')}: LT100011390613</ContactInfo>
              {/* <ContactInfo>{t('executive')}: Tadas Palaima</ContactInfo> */}
              <ContactInfo>{t('address')}: J. Jasinskio g. 12, LT-01112 Vilnius</ContactInfo>
            </Container>
            <div className='md:flex-1 min-w-full md:min-w-0 h-48 md:h-72'>
              <Map zoom={15} center={officeCoordinates}>
                <Marker
                  position={officeCoordinates}
                  popup={`FOROS Global \n J. Jasinskio g. 12, LT-01112 Vilnius`}
                />
              </Map>
            </div>
          </Container>
          {data?.countryRepresentatives.map((co, i) => (
            <CountryOffice key={`co-${i}`} {...co} />
          ))}
        </Container>
        <FooterLanding />
      </main>
    </div>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const [apolloProps, translationProps] = await Promise.all([
    fetchSSRQuery({ query: ContactsDocument }),
    serverSideTranslations(locale!, ['common', 'contacts', 'enum']),
  ])

  return {
    props: {
      ssr: true,
      ...apolloProps,
      ...translationProps,
    },
    revalidate: 60 * 60,
  }
}
